import * as v from "valibot";
import { BaseRecordSchema, baseVals, defineValidation } from "../../common/validation.common";
import { ItemGroupUnitEnum } from "../../data/enums";

export namespace WarehouseItemTypeValidation {
    export const Record = defineValidation(BaseRecordSchema);

    export const Create = defineValidation(
        v.object({
            name: baseVals.string(),
            unit: v.picklist(ItemGroupUnitEnum.values),
            notes: v.optional(baseVals.string()),
        }),
    );

    export const Update = defineValidation(
        v.object({
            name: v.exactOptional(baseVals.string()),
            notes: v.exactOptional(baseVals.string()),
        }),
    );
}
